import React from "react";
import { Box, Typography, Checkbox } from "@mui/material";
import { Emoji } from "emoji-picker-react";
import useTaskDeadline from "../../hooks/tasks/useTaskDeadline";

/**
 * A compact task display for selection lists.
 * Shows emoji, title, and a checkbox/selection indicator.
 * Reusable across TaskGuide, Day Planner, and other contexts.
 */
const CompactTaskItem = ({
  task,
  selected = false,
  onClick,
  disabled = false,
}) => {
  const { name, title, emoji, deadline, created } = task;
  const displayName = name || title;
  const { closeToDeadline } = useTaskDeadline(deadline, created, () => {});

  return (
    <Box
      className={`compact-task-item ${selected ? "compact-task-item--selected" : ""} ${disabled ? "compact-task-item--disabled" : ""} ${closeToDeadline ? "compact-task-item--urgent" : ""}`}
      onClick={disabled ? undefined : onClick}
      sx={{
        background: closeToDeadline
          ? "#cb5538 !important"
          : "#197b68 !important",
        "&:hover": {
          background: closeToDeadline
            ? "#b84a31 !important"
            : "#15695a !important",
        },
      }}
    >
      <Checkbox
        checked={selected}
        size="small"
        sx={{
          color: "rgba(255,255,255,0.5)",
          "&.Mui-checked": { color: "#fff" },
          padding: "4px",
        }}
        disabled={disabled}
      />
      {emoji && (
        <span className="compact-task-item__emoji">
          <Emoji unified={emoji} size={18} />
        </span>
      )}
      <Typography
        variant="body2"
        className="compact-task-item__title"
        sx={{
          color: "#fff !important",
        }}
      >
        {displayName}
      </Typography>
    </Box>
  );
};

export default CompactTaskItem;
